import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CheckAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
    if (!user) {
      navigate("/");
    } else {
        
    }
  }, []);
  return <div>Loading...</div>;
};

export default CheckAuth;
